<template>
  <div class="warpper">
    <HeadNei />
    <div class="content">
      <div class="flex poli_box flex_zBetween">
        <div class="poli_tel">
          <div style="height: 340px" class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>牛只规模养殖场分布</span></div>
            </div>
            <scale-pie-charts
              width="100%"
              height="220px"
              :data="cattleScaleData"
            />
          </div>
          <div style="height: 340px" class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>羊只规模养殖场分布</span></div>
            </div>
            <scale-pie width="100%" height="220px" :data="sheepScaleData" />
          </div>
          <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>实时动态</span></div>
            </div>
            <vue-seamless-scroll
              :data="dynamicData"
              class="seamless-warp"
              :class-option="classOption"
              v-if="dynamicData.length > 0"
            >
              <div
                class="poli_cel"
                v-for="(item, index) in dynamicData"
                :key="index"
              >
                {{ item }}
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <div class="poli_cent">
          <div class="poli-data whole-bgt">
            <div class="po_number">
              <div class="poli_col">
                <div style="margin-left: 10px;" class="po_col_tt">
                  备案养殖场/户
                </div>
                <div class="po_col_num">
                  {{
                    statisticsData.farmCount !== 0
                      ? statisticsData.farmCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏牛数量</div>
                <div class="po_col_num">
                  {{
                    statisticsData.existCattleCount !== 0
                      ? statisticsData.existCattleCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏羊数量</div>
                <div class="po_col_num">
                  {{
                    statisticsData.existSheepCount !== 0
                      ? statisticsData.existSheepCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏蛋鸡数量</div>
                <div class="po_col_num">
                  {{
                    statisticsData.existPoultryCount !== 0
                      ? statisticsData.existPoultryCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏生猪数量</div>
                <div class="po_col_num">
                  {{
                    statisticsData.existOtherCount !== 0
                      ? statisticsData.existOtherCount
                      : "--"
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="go-back-out">
            <span class="go-back" @click="goScreen()">返回</span>
          </div>
          <!-- map chart start -->

          <hsb-map-charts
            v-if="allMap"
            width="100%"
            height="720px"
            :regionName="regionName"
            :allMap="allMap"
            :data="mapChartData"
            :formatter="formatter"
            :isRegion="true"
          />
        </div>
        <div class="poli_tel">
          <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>存栏量趋势</span></div>
              <div class="meas-input">
                <el-select
                    v-model="exitValue"
                    placeholder="全部"
                    @change="handleTrendChange"
                    popper-class="selectPopper"
                    :popper-append-to-body="false"
                >
                  <el-option
                      v-for="(item, index) in selectOption"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                    v-model="clYear"
                    type="year"
                    :clearable="false"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder="选择年"/>
              </div>
            </div>
            <trend-line-charts
              width="100%"
              height="250PX"
              :data="exitTrendData"
            />
          </div>
          <div class="poli-cell poli_cell_b whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>入栏量统计</span></div>
              <div class="meas-input">
                <el-select
                    v-model="enterValue"
                    placeholder="全部"
                    @change="handleEnterChange"
                    popper-class="selectPopper"
                    :popper-append-to-body="false"
                >
                  <el-option
                      v-for="item in selectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                    v-model="ruLYear"
                    type="year"
                    :clearable="false"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder="选择年"/>
              </div>

            </div>
            <sta-bar-charts width="100%" height="250PX" :data="enterStaData" />
          </div>
          <div class="poli-cell poli_cell_c whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>出栏量统计</span></div>
              <div class="meas-input">
                <el-select
                    v-model="exitStaVale"
                    placeholder="全部"
                    @change="handleExitChange"
                    popper-class="selectPopper"
                    :popper-append-to-body="false"
                >
                  <el-option
                      v-for="item in selectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                    v-model="chuLYear"
                    type="year"
                    :clearable="false"
                    placeholder="选择年"
                    format="yyyy"
                    value-format="yyyy"/>
              </div>
            </div>
            <sta-bar-charts width="100%" height="250PX" :data="exitStaData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hsbJson from "@/assets/map/hsbAdminMap.json";
import HeadNei from "@/components/HeadNei.vue";
import staBarCharts from "@/components/chart/staBarCharts";
import trendLineCharts from "@/components/chart/trendLineCharts";
import hsbMapCharts from "@/components/chart/hsbMapCharts";
import vueSeamlessScroll from "vue-seamless-scroll";
// import farmTypePieCharts from "@/components/chart/farmTypePieCharts";
// import FarmTypePieCharts from "../components/chart/farmTypePieCharts.vue";
import scalePieCharts from "@/components/chart/scalePieCharts";
import scalePie from "@/components/chart/scalePie";
import moment from "moment/moment";

export default {
  name: "RegionScreen",
  components: {
    scalePie,
    scalePieCharts,
    HeadNei,
    vueSeamlessScroll,
    staBarCharts,
    trendLineCharts,
    hsbMapCharts,
    // FarmTypePieCharts,
  },
  computed: {
    classOption() {
      return {
        step: 0.5,
        limitMoveNum: this.dynamicData.length,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000,
      };
    },
  },
  data() {
    return {
      sheepScaleData: {},
      cattleScaleData: {},
      regionCode: "",
      regionName: "",
      exitTrendData: {},
      enterStaData: {},
      exitStaData: {},
      mapChartData: [],
      dynamicData: [],
      farmInfoArr: [],
      farmTypes: [],
      breedTypes: [],
      mapDatas: [],
      allMap: null,
      farmPoints: [],
      statisticsData: {
        farmCount: 0,
        existCattleCount: 0,
        existSheepCount: 0,
        existPoultryCount: 0,
        existOtherCount: 0,
      },
      selectOption: [],
      exitValue: "all",
      enterValue: "all",
      exitStaVale: "all",
      timedRefresh: null,
      // 存栏
      clYear: moment().format('YYYY'),
      // 人栏
      ruLYear: moment().format('YYYY'),
      // 出栏
      chuLYear: moment().format('YYYY'),
      formatter: {},
    };
  },
  created() {},
  beforeMount() {
    this.formatter = (ev) => {
      console.log(ev);
    };
  },
  mounted() {
    const query = this.$route.query;
    this.regionName = query.name;
    this.regionCode = query.code;

    if (this.regionName) {
      const subMap = hsbJson.features.filter((it) => {
        return it.properties.name === this.regionName;
      });
      this.allMap = { ...hsbJson, features: subMap };
    }

    this.initData();
    this.dataRefresh();
  },

  beforeDestroy() {
    this.clear();
  },
  watch: {
    clYear(){
      this.initChart(this.exitValue);
    },
    ruLYear(){
      this.initChart1(this.enterValue);
    },
    chuLYear(){
      this.initChart2(this.exitStaVale);
    }
  },
  methods: {

    // 规模养殖场分布
    async initChart4_cattle() {
      let { result } = await this.$api.center.dataDistribution({
        type: "1",
        regionCode: this.regionCode,
      });
      this.cattleScaleData = result;
    },


    async initChart4_sheep() {
      let { result } = await this.$api.center.dataDistribution({
        type: "2",
        regionCode: this.regionCode,
      });
      this.sheepScaleData = result;
    },


    goScreen() {
      this.$router.push({
        name: "Screen",
      });
    },


    dataRefresh() {
      if (this.timedRefresh != null) {
        return;
      }
      this.timedRefresh = setInterval(() => {
        this.initData();
      }, 1800000);
    },


    clear() {
      clearInterval(this.timedRefresh);
      this.timedRefresh = null;
    },


    initData() {
      this.initChart4_cattle();
      this.initChart4_sheep();
      this.initStatisticsData();
      this.initMapChart();
      this.initDynamicData();
      this.initChart("all");
      this.initChart1("all");
      this.initChart2("all");
      this.initFarmTypePipeChart();
      this.initSelectOptions();
      this.initFarmPoints();
    },

    // 初始化格式信息
    async initFormatter() {
      this.formatter = function(ev) {
        console.log(ev, "提示信息");
      };
    },

    // 养殖场点位信息
    async initFarmPoints() {
      console.log("farm points", this.regionCode);
      const { result } = await this.$api.screen.farmPoints(this.regionCode);
      this.mapChartData = result.map((item) => {
        return {
          name: item.farmName,
          value: [item.longitude, item.latitude, item.regionName],
          // value: [105.98414, 37.320373],
        };
      });
    },

    // 下拉框数据请求
    async initSelectOptions() {
      const { result } = await this.$api.screen.screenSelectOptions();
      let selectOptions = result.map((item) => {
        return {
          value: item.regionCode,
          label: item.regionName,
        };
      });
      selectOptions.unshift({
        value: "all",
        label: "全部",
      });
      this.selectOption = selectOptions;
    },

    // 统计数据请求
    async initStatisticsData() {
      this.$api.screen.screenBasicCount(this.regionCode).then((res) => {
        this.statisticsData = res.result;
      });
    },

    // 实时动态数据
    async initDynamicData() {
      // const { result } = await this.$api.screen.screenDynamic();
      // this.dynamicData = result;
      this.$api.screen.screenDynamic(this.regionCode).then((res) => {
        this.dynamicData = res.result;
      });
    },

    async initMapChart() {
      const { result } = await this.$api.screen.screenTownPoints();
      this.farmInfoArr = result;

      this.mapDatas = result.map((item) => {
        return {
          name: item.regionName,
          ...item,
        };
      });
      // this.mapChartData = result
      //   .map((item) => {
      //     return {
      //       name: item.regionName,
      //       value: [item.longitude, item.latitude]
      //     };
      //   })
      //   .filter((it) => it.name === this.regionName);
      // console.log("result", this.mapDatas);
    },

    // 存栏量趋势统计
    async initChart() {
      const params = this.regionCode;
      let { result } = await this.$api.screen.screenExistTrend(params, this.clYear);
      this.exitTrendData = result;
      // this.$api.screen
      //   .screenExistTrend({ code: this.regionCode })
      //   .then((res) => {
      //     this.exitTrendData = res.result;
      //   });
    },

    // 入栏量统计
    async initChart1() {
      const params = this.regionCode;
      let { result } = await this.$api.screen.screenEnterSta(params, this.ruLYear);
      this.enterStaData = result;
    },

    // 出栏量统计
    async initChart2() {
      const params = this.regionCode;
      let { result } = await this.$api.screen.screenExitSta(params, this.chuLYear);
      this.exitStaData = result;
    },


    async initFarmTypePipeChart() {
      let { result } = await this.$api.screen.farmTypes();
      this.farmTypes = result;
      console.log(this.$route.query);
      let { result: result1 } = await this.$api.screen.breedTypes();
      this.breedTypes = result1;
    },
    handleTrendChange(val) {
      this.initChart(val);
    },
    handleEnterChange(val) {
      this.initChart1(val);
    },
    handleExitChange(val) {
      this.initChart2(val);
    },
  },
};
</script>
<style scoped>
.warpper {
  background: url(../assets/images/nei-bj.png), #091f36;
  background-size: 100% 100%;
  min-height: 100vh;
  position: relative;
}

.poli-data {
  background-image: url(../assets/images/screen/screen_title_bg.png);
  width: 825px;
  height: 117px;
  padding: 26px 6px 0;
}
.po_number {
  display: flex;
}
.poli_col {
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.po_col_tt {
  font-size: 20px;
  font-weight: bold;
  color: #11ebf3;
  margin-right: 10px;
}

.po_col_num {
  font-size: 26px;
  font-weight: bold;
  color: #fffefe;
  /* max-width: 82px; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.poli_box {
  padding: 0 36px;
}

.poli_tel {
  width: 490px;
  position: relative;
  z-index: 99;
  margin-top: 8px;
}

.poli-cell {
  width: 100%;
  height: 345px;
  background-image: url(../assets/images/po2.png);
  padding: 20px;
}

.poli-cell + .poli-cell {
  margin-top: 39px;
}

.poli_cell_b {
  background-image: url(../assets/images/po4.png);
}

.poli_cell_c {
  background-image: url(../assets/images/po5.png);
}

.poli_head {
  width: 442px;
  height: 28px;
  background-image: url(../assets/images/po3.png);
  margin: 0 auto 20px;
  position: relative;
  line-height: 20px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.seamless-warp {
  height: 229px;
  overflow: hidden;
}

.poli_cel {
  position: relative;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  padding: 0 10px 0 34px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.poli_cel:nth-child(odd) {
  background-color: rgba(93, 154, 224, 0.06);
}

.poli_cel:nth-child(even) {
  background-color: rgba(9, 9, 9, 0.06);
}

.poli_cel span {
  color: #00bbe9;
}

.poli_cel::before {
  content: "";
  width: 10px;
  height: 3px;
  background-color: #00bbe9;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 10px;
}

.meas-name span {
  font-size: 20px;
  background-image: -webkit-linear-gradient(top, #4bbaef, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  transform: skewX(-10deg);
  display: block;
  width: max-content;
}

.meas-input{
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  top: -5px;
}

.meas-input .el-input{
  width: max-content;
}

.meas-input .el-input /deep/ .el-input__inner{
  text-align: center;
}

.poli_head /deep/ .el-select {
  //position: absolute;
  //top: -8px;
  //right: 8px;
}

.poli_head /deep/ .el-input__inner {
  background-color: rgba(31, 158, 204, 0.2);
  border-color: #00bbe9 !important;
  border-radius: 0;
  width: 102px;
  height: 30px;
  line-height: 30px;
  color: #e2ebf1;
  font-size: 14px;
  padding: 0 10px;
}

.poli_head /deep/ .el-input__icon {
  line-height: 30px;
}
.poli_head /deep/.selectPopper {
  /* background-color: rgba(31, 158, 204, 0.2); */
  background-color: rgba(9, 48, 106);
  border-color: #00bbe9 !important;
}
.poli_head /deep/ .selected {
  color: #ffffff !important;
}
.poli_head /deep/ .el-select-dropdown__item {
  color: #00bbe9;
}
.poli_head /deep/ .hover {
  color: #ffffff !important;
  background-color: rgba(31, 158, 204, 0.5);
}

.poli_cent {
  margin: 0 22px;
  width: 825px;
  height: 737px;
}

.poli-bot {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 33px 34px 35px 29px;
}
.poli-bot-box {
  min-width: 366px;
  height: 178px;
  margin-left: 6px;
  background-image: url(../assets/images/screen/screen_bot_bg.png);
  background-size: 100% 100%;
}
.poli-bot-content {
  height: 154px;
  padding: 25px 36px 0 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.poli-content-text span:first-child {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}
.poli-content-text span:last-child {
  font-size: 14px;
  font-weight: 800;
  color: #00d8ff;
}
.poli-bot-title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.go-back-out {
  display: flex;
  justify-content: right;
}
.go-back {
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid #006afa;
  margin: 10px;
  /* margin-top: 40px; */
  padding: 10px 20px;
}
</style>
